import { Grow } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { ObtenerAvances } from '../../helpers/AsuntosHelper';
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage'
import { AvanceComponent } from './AvanceComponent';
import { VacioComponent } from './VacioComponent';

export const AvancesComponent = ({actualizarAvances}) => {
    const {asuntoSeleccionado, tareaSeleccionada} = useContext(AsuntosContext);
    const [avances, setAvances] = useState();

    const obtenerAvances = (idAsunto) => {
        idAsunto = 0;
        if(tareaSeleccionada?.IdAsunto) {
            idAsunto = tareaSeleccionada?.IdAsunto
        } else {
            idAsunto = asuntoSeleccionado?.IdAsunto
        }
        ObtenerAvances(idAsunto).then(datos=>setAvances(datos));
    }

    useEffect(() => {
        obtenerAvances(asuntoSeleccionado?.IdAsunto);
    }, [actualizarAvances])
    

    useEffect(() => {
        if(tareaSeleccionada?.IdAsunto) {
            console.log('hay una tarea seleccionada')
            obtenerAvances(tareaSeleccionada?.IdAsunto);
        } else {
            console.log('mostrar avances del asunto en general');
            obtenerAvances(asuntoSeleccionado?.IdAsunto);
        }
    }, [tareaSeleccionada, asuntoSeleccionado])

    useEffect(() => {
        console.log('avances obtenidos', avances)
    }, [avances])
    

  return (
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            backgroundColor:'white',
            flex:1,
            borderRadius:10,
            padding:10,
            overflowY:'scroll',
            maxHeight:400
        }}
    >
        {
            avances?.map(avance => (
                <>
                    <AvanceComponent avance={avance} />
                </>
            ))
        }
        {
            avances?.length==0  &&(
                <VacioComponent />
            )
        }
    </div>
  )
}
